<div class="visible-lg">
  <div class="flex-container row">
    <div class="bmw-bulletin-container flex-60">
      <div class="flex-container">
        <div class="bmw-message-title flex">
          Manage Messages
        </div>
      </div>
      <div class="cms-modal-select-make-checkbox">
        <label class="container">BMW
          <input type="radio" name="bmwmsgradio" (change)="getAllMessages()" value="BMW" [(ngModel)]="makeName" >
          <span class="checkmark"></span>
        </label>
        <label class="container">MINI
          <input type="radio" name="minimsgradio" (change)="getAllMessages()" value="MINI" [(ngModel)]="makeName" >
          <span class="checkmark"></span>
        </label>
        <label class="container">MOTORRAD
          <input type="radio" name="motorradmsgradio" (change)="getAllMessages()" value="MOTORRAD" [(ngModel)]="makeName" >
          <span class="checkmark"></span>
        </label>
        <label class="container">ROLLSROYCE
          <input type="radio" name="rollsroycemsgradio" (change)="getAllMessages()"value="ROLLSROYCE" [(ngModel)]="makeName" >
          <span class="checkmark"></span>
        </label>

      </div>
      <div class="bmw-bulletin-info">
        <div class="flex-container row" style="margin-bottom: 15px">
          <div class="flex"></div>
          <div class="flex-40">
            <form class="input-group" name="findMessages" style="width: 100%">
              <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="Search Messages"
                name="techDoc" [(ngModel)]="search4messages">
              <div class="input-group-btn">
                <button [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true'), 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}" class="btn btn-default"
                  type="submit">
                  <i class="glyphicon glyphicon-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="flex-container row align-center-justify-evenly" style="border-bottom: 2px solid #b3aeae;">
          <div class="flex-container flex-75">
            <div class="bmw-message-header-label flex-60">Subject</div>
            <div class="flex-3"></div>
            <div class="bmw-message-header-label flex-20">Location</div>
            <div class="flex-3"></div>
            <div class="bmw-message-header-label flex-15">Sites</div>
          </div>
          <div class="flex-3"></div>
          <div class="bmw-message-header-label flex">Reactivate / Deactivate</div>
        </div>
        <div class="bmw-admin-message flex-container row align-center-justify-evenly" *ngFor='let message of allMessages | searchFilter: "description,location": search4messages'>
          <div class="pointer flex-container flex-75" [routerLink]='["/add-message"]' [queryParams]='{"id": message?.id}'>
            <div class="flex-60">{{message?.description}}</div>
            <div class="flex-3"></div>
            <div class="flex-20">{{message?.location}}</div>
            <div class="flex-3"></div>
            <div class="flex-15">{{message?.isBMW ? 'BMW' : message?.isMINI ? 'MINI' : message?.isMOTORRAD ? 'MOTORRAD' : message?.isROLLSROYCE ? 'ROLLSROYCE' : ''}}</div>
          </div>
          <div class="flex-3"></div>
          <div class="pointer flex" data-toggle="modal" (click)='holdMessageForAction(message)' data-target="#reactivateOrDeactivate"
            [ngStyle]="{'color': message?.isActive ? 'red' : 'green'}">{{message?.isActive ? 'Deactivate' : 'Reactivate'}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="bulletinModal" role="dialog" id='reactivateOrDeactivate'>
    <div class="bmw-cms-add-new-bulletin modal-dialog">
      <div class="modal-content bmw-csm">
        <div class="modal-body">
          <div class="pull-right flex-container row">
            <i class="material-icons pointer" data-dismiss="modal">close</i>
          </div>
          <div class="bmw-modal-text">Are you sure to Reactivate/Deactivate?</div>
          <div>
            <button class="bmw-button-secondary" data-dismiss="modal" (click)='reactivateDeactivateMessage()'>Confirm</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>